export default "__VITE_ASSET__BRps4STS__"